import { render, staticRenderFns } from "./PremiumContentModal.vue?vue&type=template&id=3d657a81&scoped=true&"
import script from "./PremiumContentModal.vue?vue&type=script&lang=js&"
export * from "./PremiumContentModal.vue?vue&type=script&lang=js&"
import style0 from "./PremiumContentModal.vue?vue&type=style&index=0&id=3d657a81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d657a81",
  null
  
)

export default component.exports